


















import Vue, { PropType } from 'vue'
import inputsMixin from '@/mixins/inputs-mixin'
import Button from '@/types/components/Button.interface'
export default Vue.extend({
    name: 'TooltipActions',
    mixins: [inputsMixin],
    props: {
        // The actions to display
        actions: {
            type: Array as PropType<Button[]>,
            required: true
        },
        // Determines if column layout is active
        vertical: {
            type: Boolean,
            required: false,
            default: false
        },
        // Determines small icon size
        small: {
            type: Boolean,
            required: false,
            default: false
        },
        // Determines x-small icon size
        xSmall: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        filteredActions(): Button[] {
            //  Grab our actions
            const actions = this.actions

            //  If we have no actions, return null
            if (!actions) return null

            //  @ts-ignore Else, filter out any hidden items
            const filtered = actions.filter((x: Button) => this.isVisible(x))

            //  If our filtered is empty, return null
            if (!filtered.length) return null

            //  Else, return the filtered
            return filtered
        }
    },
    methods: {
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        onclick(action: Button): void {
            //  Check if we are disabled
            const disabled = action.disabledPopup

            //  If we are, pop our dialog
            if (disabled) return this.disabledPopup()

            //  Else, just use our callback
            action.callback()
        }
    }
})
